import { render, staticRenderFns } from "./SlotStrip.vue?vue&type=template&id=f353b4c6&lang=pug"
import script from "./SlotStrip.vue?vue&type=script&lang=js"
export * from "./SlotStrip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Icon: require('/home/docker/code/frontend/components/Icon.vue').default})
